const isFranchiseeManagment = (user: any) => {
  if (user?.roles?.includes('user') && user?.group?.name === 'Manager') {
    return true;
  }

  return false;
};

export default isFranchiseeManagment;
